// export const Url = "https://devapi.titegypt.org";
// export const Url = "https://nilecruisesapi.titegypt.org";
export const Url = "https://api.nilecabins.info";
// export const Url = "https://nilecruisesapi.titegypt.org";
